import request from '@/utils/request';
import { ResCode, PagingReq, MeterType, PagingResData, CommonResponse, MeterCost, HolidayDate } from './baseDefine';
import { MeterList } from './meter';

export interface AddMeterCostReq {
    meterCost: MeterCost;
}

export interface GetMeterCostReq extends PagingReq {
    meterTypeID: number;
    searchCompanyID: number;
    name: string;
}
export interface GetNextMeterCostReq {
    meterCostID: number;
}
export interface QueryMeterCostReq {
    query: string;
}
export interface DeleteMeterCostReq {
    meterCostID: number;
    nextMeterCostFlag: boolean;
}

export interface UpdateMeterCostReq {
    meterCost: MeterCost;
}

export interface GetHolidayReq extends PagingReq {
    searchCompanyID: number;
    name: string;
}

export interface QueryHolidayDateReq {
    query: string;
}
export interface AddHolidayDateReq {
    holidayDate: HolidayDate;
}

export interface DeleteHolidayDateReq {
    holidayDateID: number;
}

export interface UpdateHolidayDateReq {
    holidayDate: HolidayDate;
}



export interface MeterCostRes {
    code: ResCode;
    msg: string;
    data: GetMeterCostRes;
}
export interface GetNextMeterCostRes {
    code: ResCode;
    msg: string;
    data: {
        meterCost: MeterCost;
    };
}
export interface GetMeterCostRes {
    meterCostData: MeterCostData;
}
export interface MeterCostData extends PagingResData {
    list: MeterCost[];
}

export interface HolidayDateRes {
    code: ResCode;
    msg: string;
    data: GetHolidayDateRes;
}
export interface GetHolidayDateRes {
    holidayDateData: HolidayDateData;
}
export interface HolidayDateData extends PagingResData {
    list: HolidayDate[]
}
export function addMeterCost(req: AddMeterCostReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meterCost/addMeterCost', req);
}
export function queryMeterCost(req: QueryMeterCostReq): Promise<MeterCostRes> {
    return request.post<MeterCostRes>('/api/query/meterCost', req);
}
export function deleteMeterCost(req: DeleteMeterCostReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meterCost/deleteMeterCost', req);
}
export function updateMeterCost(req: UpdateMeterCostReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meterCost/updateMeterCost', req);
}
export function meterCosts(req: GetMeterCostReq): Promise<MeterCostRes> {
    return request.post<MeterCostRes>('/api/meterCost/getMeterCosts', req);
}
export function nextMeterCost(req: GetNextMeterCostReq): Promise<GetNextMeterCostRes> {
    return request.post<GetNextMeterCostRes>('/api/meterCost/getNextMeterCost', req);
}
export function addHolidaysDate(req: AddHolidayDateReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meterCost/addHolidaysDate', req);
}
export function deleteHolidaysDate(req: DeleteHolidayDateReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meterCost/deleteHolidaysDate', req);
}
export function updateHolidaysDate(req: UpdateHolidayDateReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meterCost/updateHolidaysDate', req);
}
export function holidaysDates(req: GetHolidayReq): Promise<HolidayDateRes> {
    return request.post<HolidayDateRes>('/api/meterCost/getHolidaysDates', req);
}
export function queryHolidaysDates(req: QueryHolidayDateReq): Promise<HolidayDateRes> {
    return request.post<HolidayDateRes>('/api/meterCost/queryHolidayDates', req);
}
